import { createSlice } from '@reduxjs/toolkit';
import {
  getAllTegsThunk,
  getChatQaProjectsThunk,
  getChatQaRandomThunk,
  getChatqaResultStatisticsThunk,
  getLiveChatAgentIdThunk,
  getLiveChatAgentThunk,
  getQaInfoByAgentChatsThunk,
  getQaInfoByAgentThunk,
  patchQaChatChekedResultThunk,
  patchQaChatChekedThunk,
  getQaGroupsThunk,
  getQaGroupDetailsThunk,
  deleteQaGroupAgentThunk,
  getFreeAgentsThunk,
  applyGroupAutomationThunk,
  createQaGroupThunk,
  getQaGroupHeadsThunk,
  addAgentToGroupThunk,
  updateQaGroupThunk,
  deleteQaGroupThunk,
} from './qaActions';

const initialState = {
  chats: null,
  loading: null,
  error: null,
  createGroupError: null, // Отдельная ошибка для создания группы
  agent: null,
  agentStat: null,
  allTags: null,
  infoAgent: null,
  infoAgentChats: null,
  randomChatInfo: null,
  projects: null,
  groups: null,
  groupDetails: null,
  freeAgents: null,
  groupHeads: null,
  filters: {
    group: null,
    groupName: null,
  }
};

const qaSlice = createSlice({
  name: 'qa',
  initialState,
  reducers: {
    clearRandomChatInfo: state => {
      state.randomChatInfo = null; // Сбрасываем randomChatInfo
    },
    setQaFilter: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload
      };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getLiveChatAgentThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getLiveChatAgentThunk.fulfilled, (state, action) => {
        state.chats = action.payload;
        state.loading = false;
      })
      .addCase(getLiveChatAgentThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })

      .addCase(getLiveChatAgentIdThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getLiveChatAgentIdThunk.fulfilled, (state, action) => {
        state.agent = action.payload;
        state.loading = false;
      })
      .addCase(getLiveChatAgentIdThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })

      .addCase(patchQaChatChekedThunk.pending, state => {
        state.loading = true;
      })
      .addCase(patchQaChatChekedThunk.fulfilled, (state, action) => {
        state.agent = action.payload;
        state.loading = false;
      })
      .addCase(patchQaChatChekedThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })

      .addCase(patchQaChatChekedResultThunk.pending, state => {
        state.loading = true;
      })
      .addCase(patchQaChatChekedResultThunk.fulfilled, (state, action) => {
        state.agent = action.payload;
        state.loading = false;
      })
      .addCase(patchQaChatChekedResultThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })

      .addCase(getChatqaResultStatisticsThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getChatqaResultStatisticsThunk.fulfilled, (state, action) => {
        state.agentStat = action.payload;
        state.loading = false;
      })
      .addCase(getChatqaResultStatisticsThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })

      .addCase(getAllTegsThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getAllTegsThunk.fulfilled, (state, action) => {
        state.allTags = action.payload;
        state.loading = false;
      })
      .addCase(getAllTegsThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })

      .addCase(getQaInfoByAgentThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getQaInfoByAgentThunk.fulfilled, (state, action) => {
        state.infoAgent = action.payload;
        state.loading = false;
      })
      .addCase(getQaInfoByAgentThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(getQaInfoByAgentChatsThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getQaInfoByAgentChatsThunk.fulfilled, (state, action) => {
        state.infoAgentChats = action.payload;
        state.loading = false;
      })
      .addCase(getQaInfoByAgentChatsThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(getChatQaRandomThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getChatQaRandomThunk.fulfilled, (state, action) => {
        state.randomChatInfo = action.payload;
        state.loading = false;
      })
      .addCase(getChatQaRandomThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(getChatQaProjectsThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getChatQaProjectsThunk.fulfilled, (state, action) => {
        state.projects = action.payload;
        state.loading = false;
      })
      .addCase(getChatQaProjectsThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(getQaGroupsThunk.pending, state => {
        state.loading = true;
        state.error = null; // Очищаем ошибку при начале нового запроса
      })
      .addCase(getQaGroupsThunk.fulfilled, (state, action) => {
        // Обрабатываем пустой ответ как успешный результат
        state.groups = action.payload || [];
        state.error = null; // Очищаем ошибку при успешном ответе
        state.loading = false;
      })
      .addCase(getQaGroupsThunk.rejected, (state, action) => {
        // Улучшенная обработка ошибок
        if (action.payload) {
          state.error = action.payload;
        } else if (action.error && action.error.message) {
        state.error = action.error.message;
        } else {
          state.error = 'Ошибка при загрузке групп';
        }
        state.loading = false;
      })
      .addCase(getQaGroupDetailsThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getQaGroupDetailsThunk.fulfilled, (state, action) => {
        state.groupDetails = action.payload;
        state.loading = false;
      })
      .addCase(getQaGroupDetailsThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(deleteQaGroupAgentThunk.pending, state => {
        state.loading = true;
      })
      .addCase(deleteQaGroupAgentThunk.fulfilled, (state, action) => {
        // Обновляем список агентов в groupDetails, удаляя удаленного агента
        if (state.groupDetails && state.groupDetails.agents) {
          state.groupDetails.agents = state.groupDetails.agents.filter(
            agent => agent.id !== action.meta.arg.agentId
          );
        }
        state.loading = false;
      })
      .addCase(deleteQaGroupAgentThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(getFreeAgentsThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getFreeAgentsThunk.fulfilled, (state, action) => {
        state.freeAgents = action.payload;
        state.loading = false;
      })
      .addCase(getFreeAgentsThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(applyGroupAutomationThunk.pending, state => {
        state.loading = true;
      })
      .addCase(applyGroupAutomationThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(applyGroupAutomationThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(createQaGroupThunk.pending, state => {
        state.loading = true;
        state.createGroupError = null; // Очищаем ошибку при начале запроса
      })
      .addCase(createQaGroupThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.createGroupError = null; // Очищаем ошибку при успехе
      })
      .addCase(createQaGroupThunk.rejected, (state, action) => {
        // Улучшенная обработка ошибок
        if (action.payload) {
          state.createGroupError = action.payload;
        } else if (action.error && action.error.message) {
          state.createGroupError = action.error.message;
        } else {
          state.createGroupError = 'Неизвестная ошибка при создании группы';
        }
        state.loading = false;
      })
      .addCase(getQaGroupHeadsThunk.pending, state => {
        state.loading = true;
      })
      .addCase(getQaGroupHeadsThunk.fulfilled, (state, action) => {
        state.groupHeads = action.payload;
        state.loading = false;
      })
      .addCase(getQaGroupHeadsThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(addAgentToGroupThunk.pending, state => {
        state.loading = true;
      })
      .addCase(addAgentToGroupThunk.fulfilled, (state, action) => {
        // Обновляем список агентов в groupDetails, добавляя нового агента
        if (state.groupDetails && state.groupDetails.agents) {
          // Здесь можно добавить логику обновления списка агентов
          // если API возвращает обновленные данные
        }
        state.loading = false;
      })
      .addCase(addAgentToGroupThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(updateQaGroupThunk.pending, state => {
        state.loading = true;
      })
      .addCase(updateQaGroupThunk.fulfilled, (state, action) => {
        // Обновляем детали группы после успешного обновления
        if (state.groupDetails) {
          state.groupDetails = { ...state.groupDetails, ...action.payload };
        }
        state.loading = false;
      })
      .addCase(updateQaGroupThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(deleteQaGroupThunk.pending, state => {
        state.loading = true;
      })
      .addCase(deleteQaGroupThunk.fulfilled, (state, action) => {
        // Очищаем детали группы после удаления
        state.groupDetails = null;
        state.loading = false;
      })
      .addCase(deleteQaGroupThunk.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

export const { clearRandomChatInfo, setQaFilter } = qaSlice.actions;

export default qaSlice.reducer;
